import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {environment} from '../environments/environment';
import {AuthGuard} from './guards/auth';

const routes: Routes = [
  {
    path: 'login',
    pathMatch: 'full',
    loadChildren: () =>
      import('./pages/login/login.module').then(
        m => m.LoginModule)
  },
  {
    path: environment.routePath + '/dashboard',
    pathMatch: 'full',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/dashboard/dashboard.module').then(
        m => m.DashboardModule)
  },
  {
    path: environment.routePath + '/holidays',
    pathMatch: 'full',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/holidays/holidays.module').then(
        m => m.HolidaysModule)
  },
  {
    path: environment.routePath + '/timesheet',
    pathMatch: 'full',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/timesheet/timesheet.module').then(
        m => m.TimesheetModule)
  },
  {
    path: environment.routePath + '/budget',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/budget/new-budget/budget.module').then(
        m => m.BudgetModule)
  },
  {
    path: environment.routePath + '/budgets',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/budget/list-budgets/list-budgets.module').then(
        m => m.ListBudgetsModule)
  },
  {
    path: environment.routePath + '/works',
    pathMatch: 'full',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/prices/prices.module').then(
        m => m.PricesModule)
  },
  {path: '', redirectTo: environment.routePath + '/dashboard', pathMatch: 'full'},
  {path: '**', redirectTo: environment.routePath + '/dashboard', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
